var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"emotions",attrs:{"unselectable":"on","onmousedown":"return false;"}},_vm._l((_vm.emotionItems),function(item,index){return _c('img',{key:index,attrs:{"src":'./static/emotion_qq/'+item.fileName,"title":item.discprion,"code":item.code},on:{"click":function($event){_vm.transfertoimg(item)}}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5aa3c985","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/emotion.vue
// module id = null
// module chunks = 